import React, { useRef, useEffect, useCallback } from 'react';
import { XCircleIcon } from '@heroicons/react/20/solid';
import { useFormContext } from 'react-hook-form';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import { setCheckoutErrorMessage } from '../../redux/slices/commonSlice';

export const DismissError = ({
  useAppSelector,
  useAppDispatch,
}: ReduxSelectorProps & ReduxDispatchProps) => {
  const errorRef = useRef<HTMLDivElement | null>(null);
  const { watch } = useFormContext();
  const cardNumber = watch('CardInfo.Number');
  const nameOnCard = watch('CardInfo.NameOnCard');
  const exp = watch('CardInfo.Exp');
  const cvv = watch('CardInfo.CVV');
  const { checkoutErrorMessage } = useAppSelector(state => state.common);

  const { cartData } = useAppSelector(state => state.cart);
  const dispatch = useAppDispatch();

  const isDeclinePopup = useAppSelector(state => state.checkout.isDeclinePopup);

  const handleDismiss = useCallback(() => {
    if (setCheckoutErrorMessage) {
      dispatch(setCheckoutErrorMessage(''));
    }
  }, [setCheckoutErrorMessage]);

  useEffect(() => {
    handleDismiss();
  }, [cartData, cardNumber, nameOnCard, exp, cvv, handleDismiss]);

  useEffect(() => {
    if (checkoutErrorMessage) {
      errorRef.current?.scrollIntoView({ behavior: 'smooth' });
      if (!isDeclinePopup) {
        setTimeout(() => {
          handleDismiss();
        }, 5000);
      }
    }
  }, [checkoutErrorMessage, handleDismiss, isDeclinePopup]);

  return (
    <div>
      {(isDeclinePopup || checkoutErrorMessage) && (
        <>
          <br />
          <br />
          <div ref={errorRef} className="rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon
                  className="h-5 w-5 text-red-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  {isDeclinePopup
                    ? 'Payment has failed. Please try again.'
                    : checkoutErrorMessage}
                </h3>
                {!isDeclinePopup && (
                  <>
                    <br />
                    <button
                      type="button"
                      onClick={handleDismiss}
                      className="bg-transparent border border-red-500 hover:bg-red-200 text-blue-500 hover:text-white font-bold py-2 px-4 rounded inline-block">
                      <h3 className="text-red-800">Dismiss</h3>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
